/**
 * Asynchronously loads the component for App
 */
import PageImportFallback from '@app/components/PageImportFallback';
import loadable, { retry } from '@app/utils/loadable';

export default loadable(() => retry(() => import('./index')), {
  fallback: <PageImportFallback />,
});
